import { render, staticRenderFns } from "./IssueIgnoreDropdown.vue?vue&type=template&id=78786335"
import script from "./IssueIgnoreDropdown.vue?vue&type=script&lang=ts"
export * from "./IssueIgnoreDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,IgnoreIssueIntentional: require('/app/components/RepoIssues/Modals/IgnoreIssueIntentional.vue').default,IgnoreIssueFalsePositive: require('/app/components/RepoIssues/Modals/IgnoreIssueFalsePositive.vue').default,IgnoreIssueOccurrence: require('/app/components/RepoIssues/Modals/IgnoreIssueOccurrence.vue').default,IgnoreIssueAllFiles: require('/app/components/RepoIssues/Modals/IgnoreIssueAllFiles.vue').default,IgnoreIssueFilePattern: require('/app/components/RepoIssues/Modals/IgnoreIssueFilePattern.vue').default,IgnoreIssueTestFiles: require('/app/components/RepoIssues/Modals/IgnoreIssueTestFiles.vue').default})
